module.exports = __webpack_public_path__ + "img/Candy_bar.6a7d97b.png";